<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-goog-serch">
				<rect
					id="Rectangle_15501"
					data-name="Rectangle 15501"
					width="20"
					height="20"
					transform="translate(429 751)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44952" data-name="Mask Group 44952" transform="translate(-429 -751)" clip-path="url(#clip-path-goog-serch)">
			<g id="Layer_1-2" transform="translate(429 751)">
				<circle id="Ellipse_931" data-name="Ellipse 931" cx="10" cy="10" r="10" fill="#fff" />
				<path id="Path_33045" data-name="Path 33045" d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" fill="#969bae" />
				<path
					id="Path_33046"
					data-name="Path 33046"
					d="M10.13,3.31a6.69,6.69,0,1,0,0,13.38c5.58,0,6.84-5.18,6.32-7.81H10.13v2.23h4.32a4.464,4.464,0,1,1-1.39-4.47l1.59-1.58a6.693,6.693,0,0,0-4.51-1.75Z"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'GoogleSearchSvg',
};
</script>
